import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@breathelife/mui';

import { SubmitButton } from '../../../Components/Button/SubmitButton';
import Typography from '../../../Components/Typography';
import { ModalLayout } from '../../../Layouts/Modal/ModalLayout';

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  announcementTitle?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DeleteAnnouncementModal(props: Props): ReactElement {
  const { t } = useTranslation();
  const { isOpen, isLoading, announcementTitle, onConfirm, onCancel } = props;

  return (
    <ModalLayout
      maxWidth='sm'
      title={t('admin.announcementsManagement.deleteConfirmation.title')}
      isOpen={isOpen}
      closeModal={onCancel}
      submitButton={
        <SubmitButton
          data-testid='deleteAnnouncementConfirmationButton'
          isLoading={isLoading}
          disabled={isLoading}
          onClick={onConfirm}
        >
          {t('cta.delete')}
        </SubmitButton>
      }
    >
      <Typography variant='body1' grey={60}>
        {t('admin.announcementsManagement.deleteConfirmation.message')}
      </Typography>
      {announcementTitle && (
        <Box my={2}>
          <Typography variant='h3' component='span' grey={100}>
            {announcementTitle}
          </Typography>
        </Box>
      )}
    </ModalLayout>
  );
}
